var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
// @ts-ignore
import { iconsSvg, typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useGetSteps } from "../../utils/getSteps";
import { PaymentHeader } from "./ui/header";
import { getCustomerAction, isAlnap, isAcap, isApapAuto } from "../../fnx/customer";
import { policyCreateClearData } from "../../store/policy/actions";
import { dataFilter, paymentSummaryStorybook, } from "./resources/paymentSummaryDto";
import { PaymentSummaryView } from "./ui/view";
import { Customer } from "../../enum/customer";
import { useTranslation } from "react-i18next";
import { showToastSuccessMessage } from "../../fnx/sendSuccessMessage";
import { showErrorToast } from "../../fnx/showError";
import { quoteOne } from "../../store/generateQuote/actions";
import { personByIdClearData } from "../../store/person/actions";
import { catalogAccountTypeClearData } from "../../store/plan/actions";
import usePaymentSummary from "./components/paymentSummary";
import useUI from "./components/ui";
import useSelectors from "./components/selectors";
import { findParamInLocalStorage } from "../../utils/getAnyDataLocalStorge";
import { formatToTwoDecimals } from "../../utils/getPrice";
var PaymentSummary = function () {
    var steps2 = useGetSteps();
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var t = useTranslation().t;
    var _a = useState(false), trigger = _a[0], setTrigger = _a[1];
    var _b = useState(""), accountName = _b[0], setAccountName = _b[1];
    var _c = useState(""), accountType = _c[0], setAccountType = _c[1];
    var _d = useState([]), accountList = _d[0], setAccountList = _d[1];
    var _e = useState(""), personId = _e[0], setPersonId = _e[1];
    var _f = useState(""), accountNumber = _f[0], setAccountNumber = _f[1];
    var _g = useState(false), personTrigger = _g[0], setPersonTrigger = _g[1];
    var _h = React.useState([]), steps = _h[0], setSteps = _h[1];
    var _j = useState(""), subTitlePayment = _j[0], setSubTitlePayment = _j[1];
    var _k = useState([]), listAccountTypes = _k[0], setListAccountTypes = _k[1];
    var _l = React.useState([]), breadCrumbs = _l[0], setBreadCrumbs = _l[1];
    var _m = useState({}), dataFormPayment = _m[0], setDataFormPayment = _m[1];
    var _o = React.useState(""), projectId = _o[0], setProjectId = _o[1];
    var _p = useState(false), cardSelected = _p[0], setCardSelected = _p[1];
    var _q = useState(false), nextDisabled = _q[0], setNextDisabled = _q[1];
    var company = findParamInLocalStorage("subdomain");
    var Quote = React.useState(findParamInLocalStorage("Quote"))[0];
    var quote = Quote === null || Quote === void 0 ? void 0 : Quote.id;
    var Plan = React.useState(findParamInLocalStorage("Plan"))[0];
    var actionFlags = findParamInLocalStorage("", "afy-action-flags");
    var flagFound = actionFlags === null || actionFlags === void 0 ? void 0 : actionFlags.find(function (flag) { return flag.name === "afy-create-policy-pending-status"; });
    // Si encuentra el flag, retorna true; si no lo encuentra, retorna false
    var createPolicyPendingStatus = !!flagFound;
    console.log("actionFlags", actionFlags);
    console.log("flagFound", flagFound);
    console.log("createPolicyPendingStatus", createPolicyPendingStatus);
    var planName = (Plan === null || Plan === void 0 ? void 0 : Plan.name) || "";
    var _r = useState([]), paymentListOptions = _r[0], setPaymentListOptions = _r[1];
    var _s = useState({
        id: "",
        name: "",
        option: 0,
    }), paymentListOption = _s[0], setPaymentListOption = _s[1];
    var _t = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _t[0], setSeeToast = _t[1];
    var _u = useState({
        Name: "",
        LastNames: "",
        DocumentNumber: "",
        Email: "",
        Insurance: "",
        PlanTypeName: "",
        CampaignName: "",
        CoverType: "",
        PaymentMode: "",
        Currency: "",
        Prima: "",
        QuoteId: "",
    }), dataForm = _u[0], setDataForm = _u[1];
    var _v = useSelectors(trigger, projectId, personTrigger, personId), responseOneQuote = _v.responseOneQuote, loadingOneQuote = _v.loadingOneQuote, errorOneQuote = _v.errorOneQuote, responsePersonById = _v.responsePersonById, loadingPersonById = _v.loadingPersonById, responseCreatePolicy = _v.responseCreatePolicy, loadingCreatePolicy = _v.loadingCreatePolicy, errorCreatePolicy = _v.errorCreatePolicy, responseCatalogAccountType = _v.responseCatalogAccountType, errorCatalogAccountType = _v.errorCatalogAccountType;
    var _w = usePaymentSummary(dataForm, responseOneQuote, company, accountType, accountName, accountNumber, cardSelected, setSubTitlePayment, setDataFormPayment, setCardSelected, setSeeToast, createPolicyPendingStatus), handleChangePayment = _w.handleChangePayment, createPolicy = _w.createPolicy, loadingComplete = _w.loadingComplete;
    var _x = useUI(navigate, setAccountType, setAccountNumber, setAccountName, setCardSelected), clickCard = _x.clickCard, handlePrevious = _x.handlePrevious;
    useEffect(function () {
        setTrigger(true);
        dispatch(quoteOne({
            id: quote,
            fullBody: true,
        }));
    }, []);
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        if (responseOneQuote) {
            setDataForm({
                Name: "".concat(responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.firstNameA, " ").concat(responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.firstNameB),
                LastNames: "".concat(responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.lastNameA, " ").concat(responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.lastNameB),
                DocumentNumber: responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.numberId,
                Email: responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.email,
                Insurance: (_a = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.productId) === null || _a === void 0 ? void 0 : _a.description,
                PlanTypeName: (_b = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.planId) === null || _b === void 0 ? void 0 : _b.name,
                CampaignName: (_c = responseOneQuote.campaignId) === null || _c === void 0 ? void 0 : _c.name,
                CoverType: (_d = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.coverType) === null || _d === void 0 ? void 0 : _d.description,
                PaymentMode: (_e = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.catalogPaymentMode) === null || _e === void 0 ? void 0 : _e.description,
                Currency: getCustomerAction().customerAuto.includes(company !== null && company !== void 0 ? company : "")
                    ? (_f = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.lastPrice) === null || _f === void 0 ? void 0 : _f.currencySymbol
                    : (_h = (_g = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.planId) === null || _g === void 0 ? void 0 : _g.price) === null || _h === void 0 ? void 0 : _h.currencySymbol,
                Prima: getCustomerAction().customerAuto.includes(company !== null && company !== void 0 ? company : "")
                    ? ((_j = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.lastPrice) === null || _j === void 0 ? void 0 : _j.amount)
                        ? formatToTwoDecimals((_k = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.lastPrice) === null || _k === void 0 ? void 0 : _k.amount)
                        : "0.00"
                    : (_m = (_l = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.planId) === null || _l === void 0 ? void 0 : _l.price) === null || _m === void 0 ? void 0 : _m.amount,
                QuoteId: responseOneQuote.id,
            });
            setPersonId((_p = (_o = responseOneQuote.insured) === null || _o === void 0 ? void 0 : _o.personId) !== null && _p !== void 0 ? _p : responseOneQuote.personId);
            setPersonTrigger(true);
            setProjectId(responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.planId.projectId);
        }
    }, [responseOneQuote, company]);
    useEffect(function () {
        if (errorOneQuote) {
            showErrorToast(errorOneQuote, setSeeToast, t);
        }
    }, [errorOneQuote]);
    useEffect(function () {
        var _a, _b, _c;
        if (responsePersonById === null || responsePersonById === void 0 ? void 0 : responsePersonById.data) {
            setSubTitlePayment("");
            if (getCustomerAction().customerAuto.includes(company !== null && company !== void 0 ? company : "")) {
                if (!((_b = (_a = responsePersonById.data.additionalContentMap) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.length)) {
                    showToastSuccessMessage("Este cliente no tiene cuentas activas asociadas para realizar pagos.", typeAlert.info, setSeeToast);
                    if (planName === Customer.FULL || planName === Customer.AUTO_FULL) {
                        setSubTitlePayment("No hay cuentas disponibles para hacer el pago");
                        setPaymentListOption(paymentSummaryStorybook.paymentOptionV2);
                        setPaymentListOptions(paymentSummaryStorybook.paymentOptionsV4);
                    }
                    else {
                        setSubTitlePayment("No. Recibo de pago");
                        setPaymentListOption(paymentSummaryStorybook.paymentOptionV3);
                        setPaymentListOptions(paymentSummaryStorybook.paymentOptionsV3);
                    }
                }
                else {
                    var accountListNew = (_c = responsePersonById.data.additionalContentMap) === null || _c === void 0 ? void 0 : _c.accounts.map(function (accounts, idx) { return ({
                        id: idx + 1,
                        cardTitles: ["Tipo de Cuenta:", "Cuenta:", "Nombre:"],
                        cardValues: [accounts.type, accounts.number, accounts.category],
                        iconSvg: iconsSvg.canceledSales,
                    }); });
                    var filteredAccountList = accountListNew.filter(function (account) { return account.cardValues[0] === "CREDIT_CARD"; });
                    if (planName === Customer.FULL || planName === Customer.AUTO_FULL) {
                        setAccountList(filteredAccountList);
                    }
                    else {
                        setAccountList(accountListNew);
                    }
                    if (filteredAccountList.length === 0) {
                        setSubTitlePayment("No hay cuentas disponibles para hacer el pago");
                    }
                    if (planName === Customer.FULL || planName === Customer.AUTO_FULL) {
                        if (filteredAccountList.length === 0) {
                            setSubTitlePayment("No hay cuentas disponibles para hacer el pago");
                        }
                        else {
                            setSubTitlePayment("");
                        }
                        setPaymentListOption(paymentSummaryStorybook.paymentOptionV2);
                        setPaymentListOptions(paymentSummaryStorybook.paymentOptionsV4);
                    }
                    else {
                        setSubTitlePayment("No. Recibo de pago");
                        setPaymentListOption(paymentSummaryStorybook.paymentOptionV2); /// se cambio por el de v3
                        setPaymentListOptions(paymentSummaryStorybook.paymentOptionsV2);
                    }
                }
            }
            if (isAlnap(company)) {
                setSubTitlePayment("");
                console.log("alnap");
                setListAccountTypes([
                    {
                        id: "1",
                        name: "Cuenta de Ahorro",
                        value: "1",
                    },
                    {
                        id: "2",
                        name: "Cuenta Monetaria",
                        value: "2",
                    },
                ]);
                setPaymentListOption(paymentSummaryStorybook.paymentOptionsAlnap[0]);
                setPaymentListOptions(paymentSummaryStorybook.paymentOptionsAlnap.map(function (option) { return (__assign(__assign({}, option), { disabled: false })); }));
            }
            if (isAcap(company)) {
                console.log("acap");
                setSubTitlePayment("");
                var mockAccountList = [
                    {
                        id: 1,
                        cardTitles: ["Tipo de Cuenta:", "Cuenta:", "Nombre:"],
                        cardValues: ["DEBIT", "03102040890", "CHECKING"],
                        iconSvg: iconsSvg.canceledSales,
                    }, {
                        id: 2,
                        cardTitles: ["Tipo de Cuenta:", "Cuenta:", "Nombre:"],
                        cardValues: ["DEBIT", "05500150833", "SAVINGS"],
                        iconSvg: iconsSvg.canceledSales,
                    },
                    {
                        id: 3,
                        cardTitles: ["Tipo de Cuenta:", "Cuenta:", "Nombre:"],
                        cardValues: ["CREDIT_CARD", "40224903282", "Tarjeta de Crédito"],
                        iconSvg: iconsSvg.canceledSales,
                    },
                    {
                        id: 4,
                        cardTitles: ["Tipo de Cuenta:", "Cuenta:", "Nombre:"],
                        cardValues: ["CREDIT_CARD", "40238337121", "Tarjeta de Crédito"],
                        iconSvg: iconsSvg.canceledSales,
                    }
                ];
                setAccountList(mockAccountList);
                setPaymentListOption(paymentSummaryStorybook.paymentOptionsAcap[0]);
                setPaymentListOptions(paymentSummaryStorybook.paymentOptionsAcap.map(function (option) { return (__assign(__assign({}, option), { disabled: false })); }));
            }
            dispatch(personByIdClearData());
        }
    }, [responsePersonById, company]);
    useEffect(function () {
        if (errorCatalogAccountType) {
            showErrorToast(errorCatalogAccountType, setSeeToast, t);
        }
    }, [errorCatalogAccountType]);
    useEffect(function () {
        var _a, _b, _c;
        if (!getCustomerAction().customerAuto.includes(company !== null && company !== void 0 ? company : "")) {
            if (responseCatalogAccountType &&
                ((_a = responseCatalogAccountType.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                var data = (_b = responseCatalogAccountType.data) === null || _b === void 0 ? void 0 : _b.map(function (account) {
                    var _a;
                    return {
                        id: account.catalogAccountTypeId,
                        value: account.catalogAccountTypeId,
                        name: (_a = account.catalogAccountType) === null || _a === void 0 ? void 0 : _a.description,
                    };
                });
                setListAccountTypes(data);
                dispatch(catalogAccountTypeClearData());
                setPaymentListOption(paymentSummaryStorybook.paymentOptionV3);
                setPaymentListOptions(paymentSummaryStorybook.paymentOptionsV2);
            }
            else if (responseCatalogAccountType &&
                ((_c = responseCatalogAccountType.data) === null || _c === void 0 ? void 0 : _c.length) === 0) {
                setPaymentListOptions(paymentSummaryStorybook.paymentOptionsV3);
                setPaymentListOption(paymentSummaryStorybook.paymentOptionV3);
            }
        }
    }, [responseCatalogAccountType, company]);
    useEffect(function () {
        if (responseCreatePolicy && responseCreatePolicy.data) {
            setNextDisabled(false);
            dispatch(policyCreateClearData());
            dispatch(policyCreateClearData());
        }
    }, [responseCreatePolicy]);
    useEffect(function () {
        if (errorCreatePolicy) {
            showErrorToast(errorCreatePolicy, setSeeToast, t);
            setNextDisabled(true);
        }
    }, [errorCreatePolicy]);
    return (_jsxs(React.Fragment, { children: [_jsx(PaymentHeader, { loading: loadingOneQuote || loadingPersonById || loadingComplete, loadingCreatePolicy: loadingCreatePolicy, breadCrumbs: breadCrumbs, steps: steps2, seeToast: seeToast, setSeeToast: setSeeToast, title: paymentSummaryStorybook.title }), _jsx(PaymentSummaryView, { breadCrumbs: breadCrumbs, steps: steps, seeToast: seeToast, setSeeToast: setSeeToast, accountName: "".concat(dataForm.Name, " ").concat(dataForm.LastNames), nextLabel: paymentSummaryStorybook.nextLabel, options: listAccountTypes, paymentOption: paymentListOption, paymentOptions: paymentListOptions, hideSubTitlePayment: true, subTitlePayment: subTitlePayment, previousLabel: paymentSummaryStorybook.previousLabel, stepProgress: paymentSummaryStorybook.stepProgress, onBack: handlePrevious, filters: dataFilter(dataForm), dataForm: dataForm, onNext: createPolicy, onChangePayment: handleChangePayment, accountList: accountList, onClickCard: clickCard, 
                // voucherMaxLength={isApapAuto(company) ? 12 : 20}
                // voucherMinLength={isApapAuto(company) ? 12 : 1}
                voucherMaxLength: 20, voucherMinLength: 1, voucherIsAlphaNumeric: isApapAuto(company) ? true : false, nextDisabled: nextDisabled, loading: loadingOneQuote || loadingPersonById, loadingCreatePolicy: loadingCreatePolicy })] }));
};
export default PaymentSummary;
